import { render, staticRenderFns } from "./splitDetailDialog.vue?vue&type=template&id=63f9e446&"
import script from "./splitDetailDialog.vue?vue&type=script&lang=js&"
export * from "./splitDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./splitDetailDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports